import { http } from 'http';
import { userAcessTokenAndType } from 'helpers/user';
import NProgressApp from 'utils/nprogress';

// Request interceptor
http.interceptors.request.use(
  async config => {
    const loading = config.loading !== undefined ? config.loading : true;
    const token = await userAcessTokenAndType();
    if (loading) {
      NProgressApp.start();
    }
    if (token) {
      /* eslint no-param-reassign: ["error", { "props": true,
      "ignorePropertyModificationsFor": ["config"] }] */
      config.headers.Authorization = `${token.token_type} ${token.access_token}`;
    } else {
      window.location.href = '/';
    }
    return config;
  },
  error => Promise.reject(error.data)
);

// Response interceptor
http.interceptors.response.use(
  response => {
    const loading = response.config.loading !== undefined ? response.config.loading : true;
    if (loading) {
      NProgressApp.done();
    }
    return Promise.resolve(response);
  },
  error => {
    NProgressApp.done();
    // Do something with response error
    return Promise.reject(error);
  }
);
